import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Maximize, MapPin, Trees, Home } from "lucide-react";
import { MatchPill } from "../ListingCard";
import { koopHref, SALE_STATUS_LABEL } from "./koopUtils";

export const KoopCard = ({ listing }) => {
  const img = listing.image || (listing.gallery && listing.gallery[0]);
  const isSold = listing.status === "verkocht" || listing.status === "verkocht_ov";
  return (
    <Link
      to={koopHref(listing)}
      data-testid={`koop-card-${listing.id}`}
      className="group block overflow-hidden rounded-3xl border border-border bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-100">
        {img ? (
          <img src={img} alt={listing.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center text-slate-300"><Home size={40} /></div>
        )}
        <div className="absolute left-3 top-3 flex gap-2">
          {listing.status && listing.status !== "actief" && (
            <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${isSold ? "bg-navy text-white" : "bg-amber-500 text-white"}`}>
              {SALE_STATUS_LABEL[listing.status]}
            </span>
          )}
        </div>
        {typeof listing.match_score === "number" && (
          <div className="absolute right-3 top-3"><MatchPill score={listing.match_score} /></div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="truncate font-display text-base font-bold text-navy">{listing.title || `${listing.property_type} in ${listing.city}`}</h3>
            <p className="mt-0.5 flex items-center gap-1 truncate text-sm text-slate-500">
              <MapPin size={13} /> {listing.street}, {listing.city}
            </p>
          </div>
          <div className="shrink-0 text-right">
            <div className="font-display text-lg font-extrabold text-navy">{listing.price_label}</div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-2 text-xs font-medium text-slate-600">
          <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 px-2.5 py-1"><BedDouble size={13} /> {listing.bedrooms} slaapk.</span>
          <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 px-2.5 py-1"><Maximize size={13} /> {listing.m2} m²</span>
          {listing.plot_m2 ? (
            <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 px-2.5 py-1"><Trees size={13} /> {listing.plot_m2} m² perceel</span>
          ) : null}
          {listing.energy_label && listing.energy_label !== "—" && (
            <span className="inline-flex items-center gap-1 rounded-full bg-slate-50 px-2.5 py-1">Label {listing.energy_label}</span>
          )}
        </div>
        <div className="mt-3 border-t border-border pt-3 text-xs font-semibold text-slate-400">
          {listing.agency_name || "Makelaar"}
        </div>
      </div>
    </Link>
  );
};
